export default "__VITE_ASSET__BEL5ZgOU__"